import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/client/components/base/card";

const AnalysisPage = () => (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">
        <h1 className="text-2xl font-semibold tracking-tight">Analysis</h1>
        <p className="mt-1 text-sm text-muted-foreground">
            Research tools and analytics on market data.
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            <Card>
                <CardHeader>
                    <CardTitle>Returns Analysis</CardTitle>
                    <CardDescription>Stocks &amp; Indices</CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col gap-1 text-sm">
                    <p className="text-muted-foreground">
                        Daily close-to-close, close-to-next-open, intraday and gap returns with counts, magnitudes,
                        total return and CAGR over rolling periods.
                    </p>
                    <Link
                        to="/analysis/returns"
                        className="mt-2 inline-flex items-center gap-1.5 font-medium text-primary underline-offset-4 hover:underline"
                    >
                        Open Returns Analysis
                        <ArrowRightIcon className="size-3.5" />
                    </Link>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle>Expiry Returns</CardTitle>
                    <CardDescription>NIFTY 50</CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col gap-1 text-sm">
                    <p className="text-muted-foreground">
                        Weekly and monthly expiry-to-expiry return distributions.
                    </p>
                    <Link
                        to="/analysis/expiry-returns/weekly/NIFTY_50"
                        className="mt-2 inline-flex items-center gap-1.5 font-medium text-primary underline-offset-4 hover:underline"
                    >
                        Weekly returns
                        <ArrowRightIcon className="size-3.5" />
                    </Link>
                    <Link
                        to="/analysis/expiry-returns/monthly/NIFTY_50"
                        className="inline-flex items-center gap-1.5 font-medium text-primary underline-offset-4 hover:underline"
                    >
                        Monthly returns
                        <ArrowRightIcon className="size-3.5" />
                    </Link>
                </CardContent>
            </Card>

            <Card>
                <CardHeader>
                    <CardTitle>Trade Log</CardTitle>
                    <CardDescription>TradingView CSV Analysis</CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col gap-1 text-sm">
                    <p className="text-muted-foreground">
                        Upload your TradingView CSV trade log for comprehensive analytics and metrics.
                    </p>
                    <Link
                        to="/analysis/trade-log"
                        className="mt-2 inline-flex items-center gap-1.5 font-medium text-primary underline-offset-4 hover:underline"
                    >
                        Open Trade Log Analysis
                        <ArrowRightIcon className="size-3.5" />
                    </Link>
                </CardContent>
            </Card>
        </div>
    </div>
);

export default AnalysisPage;
